// auto-generated by build-api  2026-06-18T07:21:15.353Z

const SiteConfig = {
    System:          "ttest6c",
    SiteName:        "ttest6c",
    SiteNameShort:   "ttest6c",
    SiteTitle:       "ttest6c",
    SiteDescription: "",
    TextSlide:       "",
    DefaultTheme:    "v127",
    LogoUrl:         "",
    LogoImg:         "",
    LineContact:     "",
    Copyright:       "Copyright © 2026 ttest6c All Rights Reserved.",
    DefaultLang:      "th",
    AllowedLangs:     ["th"],
    GoogleTag:        "",
    NavbarMenuItems:  [
            {
                    "img": "https://cdn.javisx.com/image/626ca9c5-9f59-418f-ad46-bfbbe04955f4.png",
                    "url": "/luckyfortune",
                    "labelKey": "lucky_wheel_short",
                    "enabled": true,
                    "labels": {
                            "th": "กงล้อ",
                            "en": "Wheel",
                            "zh": "转盘",
                            "ja": "ホイール",
                            "my": "ဘီး",
                            "lo": "ລໍ້"
                    }
            },
            {
                    "img": "/images/cdn/108a6343-39d2-4078-fef9-97059fe4dc00.png",
                    "url": "/cardminigame",
                    "labelKey": "open_card",
                    "enabled": true,
                    "labels": {
                            "th": "เปิดไพ่",
                            "en": "Card Game",
                            "zh": "开牌游戏",
                            "ja": "カードゲーム",
                            "my": "ဖဲဖွင့်မည်",
                            "lo": "ເປີດໄພ"
                    }
            },
            {
                    "img": "/images/cdn/0cb78f94-6901-4b9c-1b54-6b5a19daf200.gif",
                    "url": "/checkindaily",
                    "labelKey": "checkin_short",
                    "enabled": true,
                    "labels": {
                            "th": "เชคอิน",
                            "en": "Check-In",
                            "zh": "签到",
                            "ja": "チェックイン",
                            "my": "စစ်ဆေး",
                            "lo": "ເຊັກອິນ"
                    }
            },
            {
                    "img": "/images/cdn/0e14db76-20a6-475b-6817-fc03e2771e00.png",
                    "url": "/loss",
                    "labelKey": "loss_short",
                    "enabled": true,
                    "labels": {
                            "th": "ยอดเสีย",
                            "en": "Loss",
                            "zh": "亏损",
                            "ja": "損失",
                            "my": "ရှုံးငွေ",
                            "lo": "ຍອດເສຍ"
                    }
            },
            {
                    "img": "/images/cdn/8845b4ec-2be0-4f00-78bd-63a49f439000.gif",
                    "url": "/promotion",
                    "labelKey": "promotion",
                    "enabled": true,
                    "labels": {
                            "th": "โปรโมชั่น",
                            "en": "Promotions",
                            "zh": "优惠活动",
                            "ja": "プロモーション",
                            "my": "ပရိုမိုးရှင်း",
                            "lo": "ໂປໂມຊັ່ນ"
                    }
            }
    ],
    OtpEnabled:       false,
}

export default SiteConfig
export const Systems = SiteConfig.System
export const LogoUrl = SiteConfig.LogoUrl
export const LogoImg = SiteConfig.LogoImg
export const OtpEnabled = SiteConfig.OtpEnabled
